<template>
  <div class="tlp">
    <div class="tlp__canvas">
      <header class="tlp__header" aria-label="TITAN">
        <div class="tlp__content-inner tlp__header-inner">
          <div class="tlp__header-brand">
            <img
              class="tlp__logo"
              :src="imageUrl('/shopadmin/logo_lp.svg')"
              alt="TITAN"
              width="120"
              height="36"
              decoding="async" />
            <p class="tlp__tagline">
              飲食店向け インバウンド集客自動化ツール
            </p>
          </div>
          <a
            class="tlp__cta"
            href="https://titan-g.com/signup"
            target="_blank"
            rel="noopener noreferrer">
            無料会員登録
          </a>
        </div>
      </header>
      <section
        class="tlp__promo-banner"
        role="region"
        aria-label="キャンペーン案内">
        <div class="tlp__content-inner tlp__promo-inner">
          <p class="tlp__promo-text">
            【グルプラ会員様限定】初期費用無料＆特別プラン キャンペーン実施中！
          </p>
        </div>
      </section>
      <main class="tlp__main">
        <section
          class="tlp__mv"
          aria-labelledby="titan-lp-mv-heading">
          <div class="tlp__mv-bg" aria-hidden="true">
            <img
              class="tlp__mv-bg-img"
              :src="imageUrl('/shopadmin/mv_bg.jpg')"
              alt=""
              width="3996"
              height="2080"
              fetchpriority="high"
              loading="eager"
              decoding="async" />
          </div>
          <div class="tlp__content-inner tlp__mv-inner">
            <div class="tlp__mv-copy">
              <h1
                id="titan-lp-mv-heading"
                class="tlp__mv-title">
                訪日客を<br />
                取りこぼしたくない<br />
                <span class="tlp__mv-title-pill">飲食店オーナー様</span>へ
              </h1>
              <p class="tlp__mv-lead">
                Googleマップ・検索広告を活用して<br />
                自動でインバウンド集客しませんか？
              </p>
              <p class="tlp__mv-desc">
                Web広告の知識は一切不要。AIが運用を自動化し、<br />
                "見つけられるお店"から"選ばれるお店"へと導きます。
              </p>
              <a
                class="tlp__mv-cta"
                href="https://titan-g.com/signup"
                target="_blank"
                rel="noopener noreferrer">
                <span class="tlp__mv-cta-badge">最短1分、初期費用0円</span>
                <span class="tlp__mv-cta-main">無料会員登録はこちら</span>
              </a>
            </div>
            <div class="tlp__mv-visual">
              <img
                class="tlp__mv-visual-img"
                :src="imageUrl('/shopadmin/mv_right.png')"
                alt=""
                width="625"
                height="859"
                loading="eager"
                decoding="async" />
            </div>
          </div>
        </section>
      </main>
      <section
        class="tlp__problem"
        aria-labelledby="titan-lp-problem-title">
        <div class="tlp__content-inner">
          <h2 id="titan-lp-problem-title" class="tlp__section-title">
            こんなお悩みはありませんか？
          </h2>
          <div class="tlp__problem-title-bar" aria-hidden="true"></div>
          <ul class="tlp__problem-grid" role="list">
            <li
              v-for="(item, index) in problemItems"
              :key="index"
              class="tlp__problem-card">
              <div class="tlp__problem-card-header">
                <svg class="tlp__problem-icon" width="44" height="44" viewBox="0 0 44 44" fill="none"
                  xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false">
                  <path
                    d="M0 22C0 9.84974 9.84974 0 22 0C34.1503 0 44 9.84974 44 22C44 34.1503 34.1503 44 22 44C9.84974 44 0 34.1503 0 22Z"
                    fill="#FFE2E2" />
                  <path
                    d="M22 33.6667C28.4433 33.6667 33.6667 28.4433 33.6667 22C33.6667 15.5567 28.4433 10.3333 22 10.3333C15.5567 10.3333 10.3333 15.5567 10.3333 22C10.3333 28.4433 15.5567 33.6667 22 33.6667Z"
                    stroke="#E7000B" stroke-width="2.33333" stroke-linecap="round" stroke-linejoin="round" />
                  <path d="M18.5 22L20.8333 24.3333L25.5 19.6667" stroke="#E7000B" stroke-width="2.33333"
                    stroke-linecap="round" stroke-linejoin="round" />
                </svg>
                <p class="tlp__problem-card-text">{{ item.text }}</p>
              </div>
              <img
                class="tlp__problem-card-illust"
                :src="imageUrl(item.illust)"
                alt=""
                width="356"
                height="140"
                loading="lazy"
                decoding="async" />
            </li>
          </ul>
          <div class="tlp__problem-callout" aria-label="まとめ">
            <p class="tlp__problem-callout-line">そのお悩みは、需要がないからではなく、</p>
            <p class="tlp__problem-callout-em">「お店の魅力が訪日客に見つけられていない」</p>
            <p class="tlp__problem-callout-line">だけかもしれません。</p>
          </div>
        </div>
      </section>
      <section
        class="tlp__support"
        aria-labelledby="titan-lp-support-title">
        <div class="tlp__content-inner">
          <h2 id="titan-lp-support-title" class="tlp__section-title">
            TITANが、訪日客の集客の仕組みを一括でサポート
          </h2>
          <p class="tlp__section-lead">
            専門知識やお時間は一切不要です。AI技術と飲食専門のプロが、<br />
            自動で成果に繋がるシステムを構築いたします。
          </p>
          <div class="tlp__support-grid-wrap">
            <div class="tlp__support-grid-line" aria-hidden="true"></div>
            <ul class="tlp__support-grid" role="list">
              <li
                v-for="(item, index) in supportItems"
                :key="index"
                class="tlp__support-card">
                <div class="tlp__support-card-num" aria-hidden="true">{{ item.num }}</div>
                <div class="tlp__support-card-illust-wrap">
                  <img
                    class="tlp__support-card-illust"
                    :src="imageUrl(item.illust)"
                    alt=""
                    width="332"
                    height="180"
                    loading="lazy"
                    decoding="async" />
                </div>
                <h3 class="tlp__support-card-title">{{ item.title }}</h3>
                <p class="tlp__support-card-desc">{{ item.desc }}</p>
              </li>
            </ul>
          </div>
        </div>
      </section>
      <section
        class="tlp__optimize"
        aria-labelledby="titan-lp-optimize-title">
        <div class="tlp__content-inner">
          <h2 id="titan-lp-optimize-title" class="tlp__section-title">
            来店までの行動を可視化し、確実に改善
          </h2>
          <p class="tlp__section-lead">
            単なる表示回数ではなく、実来店に直結するアクションを増やします。
          </p>
          <div class="tlp__optimize-flow">
            <img
              class="tlp__optimize-flow-img"
              :src="imageUrl('/shopadmin/optimize_flow.png')"
              alt="来店までの行動を可視化"
              width="611"
              height="179"
              loading="lazy"
              decoding="async" />
          </div>
          <div class="tlp__optimize-features">
            <div class="tlp__optimize-feature-card">
              <div class="tlp__optimize-feature-icon-wrap" aria-hidden="true">
                <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M16 10.6668V5.3335H10.6667" stroke="#155DFC" stroke-width="2.66667" stroke-linecap="round"
                    stroke-linejoin="round" />
                  <path
                    d="M24 10.6665H8C6.52724 10.6665 5.33333 11.8604 5.33333 13.3332V23.9998C5.33333 25.4726 6.52724 26.6665 8 26.6665H24C25.4728 26.6665 26.6667 25.4726 26.6667 23.9998V13.3332C26.6667 11.8604 25.4728 10.6665 24 10.6665Z"
                    stroke="#155DFC" stroke-width="2.66667" stroke-linecap="round" stroke-linejoin="round" />
                  <path d="M2.66667 18.6665H5.33333M26.6667 18.6665H29.3333M20 17.3335V20.0002M12 17.3335V20.0002"
                    stroke="#155DFC" stroke-width="2.66667" stroke-linecap="round" stroke-linejoin="round" />
                </svg>
              </div>
              <div class="tlp__optimize-feature-content">
                <h3 class="tlp__optimize-feature-title">AIによる自動最適化</h3>
                <p class="tlp__optimize-feature-desc">
                  配信開始後は、AIが常に効果を分析。予算内で最大限の効果が得られるよう、表示タイミングやターゲット、入札単価を自動で調整します。
                </p>
              </div>
            </div>
            <div class="tlp__optimize-feature-card">
              <div class="tlp__optimize-feature-icon-wrap tlp__optimize-feature-icon-wrap--orange" aria-hidden="true">
                <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path
                    d="M4 14.6665H8C8.70724 14.6665 9.38552 14.9475 9.88562 15.4476C10.3857 15.9477 10.6667 16.6259 10.6667 17.3332V21.3332C10.6667 22.0404 10.3857 22.7187 9.88562 23.2188C9.38552 23.7189 8.70724 23.9998 8 23.9998H6.66667C5.95942 23.9998 5.28115 23.7189 4.78105 23.2188C4.28095 22.7187 4 22.0404 4 21.3332V14.6665ZM4 14.6665C4 13.0906 4.31039 11.5302 4.91345 10.0743C5.5165 8.6184 6.40042 7.29553 7.51472 6.18122C8.62902 5.06692 9.95189 4.18301 11.4078 3.57995C12.8637 2.97689 14.4241 2.6665 16 2.6665C17.5759 2.6665 19.1363 2.97689 20.5922 3.57995C22.0481 4.18301 23.371 5.06692 24.4853 6.18122C25.5996 7.29553 26.4835 8.6184 27.0866 10.0743C27.6896 11.5302 28 13.0906 28 14.6665M28 14.6665V21.3332C28 22.0404 27.719 22.7187 27.219 23.2188C26.7189 23.7189 26.0406 23.9998 25.3333 23.9998H24C23.2928 23.9998 22.6145 23.7189 22.1144 23.2188C21.6143 22.7187 21.3333 22.0404 21.3333 21.3332V17.3332C21.3333 16.6259 21.6143 15.9477 22.1144 15.4476C22.6145 14.9475 23.2928 14.6665 24 14.6665H28Z"
                    stroke="#F54900" stroke-width="2.66667" stroke-linecap="round" stroke-linejoin="round" />
                  <path
                    d="M28 21.3335V24.0002C28 25.4147 27.4381 26.7712 26.4379 27.7714C25.4377 28.7716 24.0812 29.3335 22.6667 29.3335H16"
                    stroke="#F54900" stroke-width="2.66667" stroke-linecap="round" stroke-linejoin="round" />
                </svg>
              </div>
              <div class="tlp__optimize-feature-content">
                <h3 class="tlp__optimize-feature-title">飲食のプロによる徹底サポート</h3>
                <p class="tlp__optimize-feature-desc">
                  2000店舗以上の支援実績を持つ専門チームが伴走。初期設定から日々の運用相談まで、オンラインで手厚くサポートいたします。
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section
        class="tlp__results"
        aria-labelledby="titan-lp-results-title">
        <div class="tlp__content-inner">
          <h2 id="titan-lp-results-title" class="tlp__section-title">
            圧倒的な導入成果
          </h2>
          <p class="tlp__section-lead">
            インバウンド需要を確実に利益へ繋げています。
          </p>
          <div class="tlp__results-list">
            <article v-for="(item, ri) in resultsItems" :key="ri" class="tlp__results-card">
              <img
                class="tlp__results-card-bg"
                :src="imageUrl('/shopadmin/results_card_bg.svg')"
                alt=""
                aria-hidden="true" />
              <div class="tlp__results-card-body">
                <div class="tlp__results-tags">
                  <span class="tlp__results-tag tlp__results-tag--location">{{ item.location }}</span>
                  <span class="tlp__results-tag tlp__results-tag--category">{{ item.category }}</span>
                  <span class="tlp__results-tag tlp__results-tag--period">{{ item.period }}</span>
                </div>
                <h3 class="tlp__results-card-title">{{ item.title }}</h3>
                <p class="tlp__results-card-desc">{{ item.desc }}</p>
              </div>
              <div class="tlp__results-metrics">
                <div v-for="(metric, mi) in item.metrics" :key="mi" class="tlp__results-metric">
                  <div class="tlp__results-metric-before">
                    <span>Before</span>
                    <span>{{ metric.before }}</span>
                  </div>
                  <div class="tlp__results-metric-name">{{ metric.name }}</div>
                  <div class="tlp__results-metric-after">
                    <span class="tlp__results-metric-after-num">{{ metric.afterNum }}</span><span
                      class="tlp__results-metric-after-suffix">{{ metric.afterSuffix }}</span>
                  </div>
                  <img
                    class="tlp__results-metric-illust"
                    :src="imageUrl(metric.illust)"
                    alt=""
                    loading="lazy"
                    decoding="async" />
                </div>
              </div>
            </article>
          </div>
        </div>
      </section>
      <section
        class="tlp__matching"
        aria-labelledby="titan-lp-matching-title">
        <div class="tlp__content-inner">
          <h2 id="titan-lp-matching-title" class="tlp__section-title">
            TITANがフィットする店舗様
          </h2>
          <div class="tlp__matching-grid">
            <div class="tlp__matching-card tlp__matching-card--fit">
              <h3 class="tlp__matching-card-title">
                <span class="tlp__matching-card-title-icon-wrap" aria-hidden="true">
                  <svg class="tlp__matching-card-title-icon" width="28" height="28" viewBox="0 0 20 20" fill="none"
                    xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false">
                    <path d="M16.6666 5L7.49992 14.1667L3.33325 10" stroke="#05DF72" stroke-width="2.5"
                      stroke-linecap="round" stroke-linejoin="round" />
                  </svg>
                </span>
                <span class="tlp__matching-card-title-text">特に効果を実感いただきやすい<br />店舗様</span>
              </h3>
              <ul class="tlp__matching-list" role="list">
                <li v-for="(item, index) in matchingFitItems" :key="index" class="tlp__matching-item">
                  <svg class="tlp__matching-check" width="24" height="24" viewBox="0 0 24 24" fill="none"
                    xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false">
                    <path
                      d="M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z"
                      stroke="#00C950" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                    <path d="M9 12L11 14L15 10" stroke="#00C950" stroke-width="2" stroke-linecap="round"
                      stroke-linejoin="round" />
                  </svg>
                  <span class="tlp__matching-text">{{ item }}</span>
                </li>
              </ul>
              <div class="tlp__matching-illust-wrap">
                <img
                  class="tlp__matching-illust"
                  :src="imageUrl('/shopadmin/matching_illust_fit.png')"
                  alt=""
                  width="492"
                  height="106"
                  loading="lazy"
                  decoding="async" />
              </div>
            </div>
            <div class="tlp__matching-card tlp__matching-card--unfit">
              <h3 class="tlp__matching-card-title">
                <span class="tlp__matching-card-title-icon-wrap" aria-hidden="true">
                  <svg class="tlp__matching-card-title-icon" width="28" height="28" viewBox="0 0 28 28" fill="none"
                    xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false">
                    <path d="M5.83325 14H22.1666" stroke="#79716B" stroke-width="3.5" stroke-linecap="round"
                      stroke-linejoin="round" />
                  </svg>
                </span>
                <span class="tlp__matching-card-title-text">本サービスが合わない可能性が<br />ある店舗様</span>
              </h3>
              <ul class="tlp__matching-list tlp__matching-list--unfit" role="list">
                <li v-for="(item, index) in matchingUnfitItems" :key="index" class="tlp__matching-item">
                  <span class="tlp__matching-check-wrap" aria-hidden="true">
                    <svg class="tlp__matching-check" width="24" height="24" viewBox="0 0 24 24" fill="none"
                      xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false">
                      <path d="M5 12H19" stroke="#A6A09B" stroke-width="2" stroke-linecap="round"
                        stroke-linejoin="round" />
                    </svg>
                  </span>
                  <span class="tlp__matching-text">{{ item }}</span>
                </li>
              </ul>
              <div class="tlp__matching-illust-wrap">
                <img
                  class="tlp__matching-illust"
                  :src="imageUrl('/shopadmin/matching_illust_unfit.png')"
                  alt=""
                  width="492"
                  height="152"
                  loading="lazy"
                  decoding="async" />
              </div>
            </div>
          </div>
        </div>
      </section>
      <section
        class="tlp__pricing"
        aria-labelledby="titan-lp-pricing-title">
        <div class="tlp__content-inner tlp__pricing-inner">
          <h2 id="titan-lp-pricing-title" class="tlp__section-title">
            まずはリスクを抑えてスタートし、<br />
            実際の来店効果をご実感ください
          </h2>
          <p class="tlp__section-lead">
            不要な固定費を抑え、自動化による効率運用で<br />
            オーナー様の利益最大化を目指します。
          </p>
          <div class="tlp__pricing-card-wrap">
            <div class="tlp__pricing-badge">
              <span class="tlp__pricing-badge-star" aria-hidden="true">✨</span>
              一番人気
              <span class="tlp__pricing-badge-star" aria-hidden="true">✨</span>
            </div>
            <div class="tlp__pricing-card">
              <div class="tlp__pricing-card-header">
                <span class="tlp__pricing-plan-tag">【グルプラ会員様限定】特別プラン</span>
                <h3 class="tlp__pricing-plan-name">システム月額利用料</h3>
                <div class="tlp__pricing-price-wrap">
                  <span class="tlp__pricing-price-prefix">毎月</span>
                  <span class="tlp__pricing-price-symbol">¥</span>
                  <span class="tlp__pricing-price-num">0</span>
                </div>
                <p class="tlp__pricing-price-note">（1店舗あたり）</p>
                <div class="tlp__pricing-condition">
                  初期費用:<span class="tlp__pricing-condition-em">無料</span> <span
                    class="tlp__pricing-condition-sep">/</span> 契約期間:1ヶ月〜
                </div>
              </div>
              <div class="tlp__pricing-card-body">
                <ul class="tlp__pricing-features" role="list">
                  <li v-for="(item, index) in pricingFeatures" :key="index" class="tlp__pricing-feature-item">
                    <span class="tlp__pricing-feature-check-wrap" aria-hidden="true">
                      <svg class="tlp__pricing-feature-check" width="20" height="20" viewBox="0 0 20 20" fill="none"
                        xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false">
                        <path d="M16.6666 5L7.49992 14.1667L3.33325 10" stroke="#05DF72" stroke-width="2.5"
                          stroke-linecap="round" stroke-linejoin="round" />
                      </svg>
                    </span>
                    <span class="tlp__pricing-feature-text">{{ item }}</span>
                  </li>
                </ul>
                <div class="tlp__pricing-action">
                  <a
                    class="tlp__pricing-btn"
                    href="https://titan-g.com/signup"
                    target="_blank"
                    rel="noopener noreferrer">
                    今すぐ無料会員登録する
                  </a>
                </div>
                <div class="tlp__pricing-notes-wrap">
                  <div class="tlp__pricing-notes">
                    <p class="tlp__pricing-note">※発生するのは実費の広告費（月額1万円〜）と、その運用手数料（30%）のみとなります。</p>
                    <p class="tlp__pricing-note">※広告費や上位プランへの変更は、管理画面からいつでも設定・確認いただけます。</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section
        class="tlp__faq"
        aria-labelledby="titan-lp-faq-title">
        <div class="tlp__content-inner">
          <h2 id="titan-lp-faq-title" class="tlp__section-title tlp__faq-title">
            よくあるご質問
          </h2>
          <ul class="tlp__faq-list" role="list">
            <li
              v-for="(item, index) in faqItems"
              :key="index"
              class="tlp__faq-item">
              <button
                type="button"
                class="tlp__faq-trigger"
                :aria-expanded="openFaqIndex === index"
                :aria-controls="`titan-lp-faq-panel-${index}`"
                :id="`titan-lp-faq-trigger-${index}`"
                @click="toggleFaq(index)">
                <span class="tlp__faq-trigger-main">
                  <span class="tlp__faq-q-mark" aria-hidden="true">Q.</span>
                  <span class="tlp__faq-q-text">{{ item.question }}</span>
                </span>
                <span
                  class="tlp__faq-icon"
                  :class="{ 'is-open': openFaqIndex === index }"
                  aria-hidden="true">
                  <span class="tlp__faq-icon-bg">
                    <span class="tlp__faq-icon-glyph">
                      <span class="tlp__faq-icon-line tlp__faq-icon-line--h"></span>
                      <span class="tlp__faq-icon-line tlp__faq-icon-line--v"></span>
                    </span>
                  </span>
                </span>
              </button>
              <div
                class="tlp__faq-anim"
                :class="{ 'is-open': openFaqIndex === index }"
                :aria-hidden="openFaqIndex !== index">
                <div class="tlp__faq-anim-inner">
                  <div
                    :id="`titan-lp-faq-panel-${index}`"
                    class="tlp__faq-panel"
                    role="region"
                    :aria-labelledby="`titan-lp-faq-trigger-${index}`">
                    <p class="tlp__faq-answer">
                      <span class="tlp__faq-a-mark" aria-hidden="true">A.</span>
                      <span class="tlp__faq-answer-body">{{ item.answer }}</span>
                    </p>
                  </div>
                </div>
              </div>
            </li>
          </ul>
        </div>
      </section>
      <section
        class="tlp__signup-cta"
        aria-labelledby="titan-lp-signup-cta-title">
        <div
          class="tlp__signup-cta-gradient-wrap"
          aria-hidden="true">
          <div class="tlp__signup-cta-gradient"></div>
        </div>
        <img
          class="tlp__signup-cta-deco tlp__signup-cta-deco--tr"
          :src="imageUrl('/shopadmin/cta_bg_right.png')"
          alt=""
          width="512"
          height="512"
          loading="lazy"
          decoding="async"
          aria-hidden="true" />
        <img
          class="tlp__signup-cta-deco tlp__signup-cta-deco--bl"
          :src="imageUrl('/shopadmin/cta_bg_left.png')"
          alt=""
          width="544"
          height="544"
          loading="lazy"
          decoding="async"
          aria-hidden="true" />
        <div class="tlp__content-inner tlp__signup-cta-inner">
          <h2 id="titan-lp-signup-cta-title" class="tlp__signup-cta-title">
            <span class="tlp__signup-cta-title-row">訪日客のGoogleマップ上の取りこぼしを、</span>
            <span class="tlp__signup-cta-title-row">
              <span class="tlp__signup-cta-highlight">ご来店チャンス</span>
              <span class="tlp__signup-cta-title-tail">に変えませんか？</span>
            </span>
          </h2>
          <p class="tlp__signup-cta-lead">
            あなたのお店が現在どれだけ機会損失しているか、<br />
            システム上ですぐに無料シミュレーションが可能です。
          </p>
          <a
            class="tlp__signup-cta-btn"
            href="https://titan-g.com/signup"
            target="_blank"
            rel="noopener noreferrer">
            無料会員登録はこちら
          </a>
          <ul class="tlp__signup-cta-features" role="list">
            <li
              v-for="(label, index) in signupCtaFeatures"
              :key="index"
              class="tlp__signup-cta-feature">
              <svg
                class="tlp__signup-cta-check"
                width="20"
                height="20"
                viewBox="0 0 20 20"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                aria-hidden="true"
                focusable="false">
                <path
                  d="M9.99984 18.3337C14.6022 18.3337 18.3332 14.6027 18.3332 10.0003C18.3332 5.39795 14.6022 1.66699 9.99984 1.66699C5.39746 1.66699 1.6665 5.39795 1.6665 10.0003C1.6665 14.6027 5.39746 18.3337 9.99984 18.3337Z"
                  stroke="#00C950"
                  stroke-width="1.66667"
                  stroke-linecap="round"
                  stroke-linejoin="round" />
                <path
                  d="M7.5 9.99967L9.16667 11.6663L12.5 8.33301"
                  stroke="#00C950"
                  stroke-width="1.66667"
                  stroke-linecap="round"
                  stroke-linejoin="round" />
              </svg>
              <span>{{ label }}</span>
            </li>
          </ul>
        </div>
      </section>
      <footer class="tlp__footer" aria-label="TITAN">
        <img
          class="tlp__footer-logo"
          :src="imageUrl('/shopadmin/logo_lp_white.svg')"
          alt="TITAN"
          width="106"
          height="28"
          decoding="async" />
      </footer>
    </div>
  </div>
</template>

<script>
export default {
  name: 'tlp',
  data() {
    return {
      openFaqIndex: null,
      problemItems: [
        {
          text: '外国人客を増やしたいが、何から始めればいいか分からない',
          illust: '/shopadmin/problem_illust_01.webp',
        },
        {
          text: 'Googleマップで競合店ばかり目立っていて埋もれている',
          illust: '/shopadmin/problem_illust_02.webp',
        },
        {
          text: '英語のメニューやページがなく、お店の魅力が伝わらない',
          illust: '/shopadmin/problem_illust_03.webp',
        },
        {
          text: '広告代理店に大きな固定費や運用費を払う予算がない',
          illust: '/shopadmin/problem_illust_04.webp',
        },
      ],
      supportItems: [
        {
          num: '01',
          title: 'お店を見つけていただく',
          desc: 'Google検索・Googleマップで、来店見込みの高い訪日客や周辺検索ユーザーへAIが自動でピンポイントに広告を配信します。',
          illust: '/shopadmin/support_illust_01.png',
        },
        {
          num: '02',
          title: '魅力を伝えて選んでいただく',
          desc: '英語ページ・店舗情報を整備し、価格帯・メニュー・アクセス・予約方法を海外のお客様にも分かりやすく最適化します。',
          illust: '/shopadmin/support_illust_02.png',
        },
        {
          num: '03',
          title: '迷わずご来店いただく',
          desc: 'ルート案内・通話・予約導線を改善し、実際のご来店を最大化できるよう徹底的に伴走・レポーティングいたします。',
          illust: '/shopadmin/support_illust_03.png',
        },
      ],
      pricingFeatures: [
        'Google検索・マップ広告 自動配信',
        'Googleマップ 初期設定・運用',
        '来店前行動のダッシュボード可視化',
        '専任スタッフによる運用改善サポート',
        '無料ホームページ作成機能 (3ヶ月)',
      ],
      resultsItems: [
        {
          location: '東京都 新宿区',
          category: 'インバウンドレストラン（和食）',
          period: '対策実施後 3ヶ月',
          title: '対策前の約54倍！\nインバウンド需要の取り込みに成功',
          desc: '対策実施前はほとんど見られていなかったマップ経由の閲覧が爆発的に増加。閲覧数の約99%がマップ経由となり、確実な集客動線が完成しました。外国語メニューの整備も合わせて行い、客単価も上昇。',
          metrics: [
            { before: '約0.5万回', name: 'ユーザー閲覧数', afterNum: '27.6', afterSuffix: '万回', illust: '/shopadmin/results_metric_01.png' },
            { before: '15%', name: 'マップ経由比率', afterNum: '99', afterSuffix: '%', illust: '/shopadmin/results_metric_02.png' },
            { before: '月間18件', name: 'ルート案内数', afterNum: '970', afterSuffix: '件', illust: '/shopadmin/results_metric_03.png' },
          ],
        },
        {
          location: '大阪府 難波',
          category: 'インバウンドレストラン（BBQ業態）',
          period: '対策実施後 1ヶ月',
          title: '英語キーワード最適化で、\n驚異的な月間検索数を記録',
          desc: '短期間での運用ながら、英語検索（BBQ near me等）に最適化したことでGoogleマップからの流入が急増。高評価の口コミ投稿を促す仕組みも導入し、来店に直結しています。',
          metrics: [
            { before: '2.1万回', name: '月間検索数', afterNum: '21.2', afterSuffix: '万回', illust: '/shopadmin/results_metric_04.png' },
            { before: '1.2万回', name: '直接検索数', afterNum: '12.4', afterSuffix: '万回', illust: '/shopadmin/results_metric_05.png' },
            { before: '3.8点', name: '口コミ評価', afterNum: '4.4', afterSuffix: '点', illust: '/shopadmin/results_metric_06.png' },
          ],
        },
      ],
      matchingFitItems: [
        '駅近・観光地・繁華街に立地している',
        '焼肉、寿司、和食、ステーキ、居酒屋業態',
        'Googleマップ流入を本気で増やしたい',
        '英語ページやGoogleマップ運用が手付かず',
        'インバウンド客をターゲットにしていきたい',
        '1〜10店舗規模で、効率よくWeb集客を始めたい',
        '英語対応に不安があり、システムに任せたい',
        '広告予算が限られており、費用対効果を重視する',
        '日々の店舗業務が忙しく、運用する時間がない',
      ],
      matchingUnfitItems: [
        '完全会員制・紹介制で営業している',
        '訪日外国人客の受け入れを一切希望しない',
        'Webからの予約導線を整えることができない',
        '郊外立地で、ターゲットが車来店の地元客のみ',
        'Web集客やデジタル化に全く興味がない',
        '月額1万円の広告費もかけられない',
      ],
      faqItems: [
        {
          question: '実績の数値は実売上ですか？',
          answer:
            '一部数値はGoogle広告・Googleマップ上の行動指標をもとにした想定値です。ルート案内、通話、予約、保存など、ご来店につながる具体的なアクションを可視化し、それをもとに改善提案を行わせていただきます。',
        },
        {
          question: '広告やホームページの知識がなくても大丈夫ですか？',
          answer:
            '全く問題ございません。TITANは「現場スタッフ様でも扱える」ことを思想に設計されており、AIが自動で最適化を行います。初期設定から日々の運用、レポートの解説まで専任スタッフが丁寧にサポートいたします。',
        },
        {
          question: 'インバウンド向けのWeb広告は素人でも本当にできますか？',
          answer:
            'はい、可能です。TITANはプロの広告運用ノウハウをシステム化・AI化しているため、業種やターゲットを選ぶだけで、専門知識がなくても最適なキーワード設定や広告配信が自動で行われます。',
        },
        {
          question: 'どのような店舗が成果が出やすいですか？',
          answer:
            '観光地や繁華街、駅近にあり、周辺を歩いている外国人が多いほど効果が速やかに現れます。特に、他店様がまだマップ対策をされていない場合は、非常に高い成果が期待できます。',
        },
        {
          question: '初期設定は難しいですか？',
          answer:
            'ご安心ください。アカウント登録後、分かりやすい設定画面に沿って進めるだけで完了します。ご不明点があれば専門スタッフがサポートいたしますので、パソコン操作が苦手な方でも問題なく始められます。',
        },
        {
          question: '日々の運用で手間はかかりますか？',
          answer:
            '日々の運用はAIが自動で最適化するため、オーナー様の手を煩わせることはありません。分かりやすいダッシュボードで効果を確認するだけで運用が可能です。',
        },
        {
          question: '契約期間の縛りはありますか？',
          answer:
            'プランにより異なりますが、フリープランであれば1ヶ月単位でのご利用が可能です。まずはリスクを抑えて効果をお試しいただけます。',
        },
        {
          question: '広告費はいくらから始められますか？',
          answer:
            '月額1万円の少額から広告配信をスタートすることが可能です。ご予算に合わせてAIが最大限の効果を発揮できるよう自動調整します。',
        },
        {
          question: '月額費用が本当に毎月0円のプランがあるのですか？',
          answer:
            'はい、ございます。フリープランではシステム月額利用料は「毎月0円」で継続利用いただけます。発生するのは実費の広告費とその運用手数料（30%）のみとなります。',
        },
        {
          question: '無料会員登録すると何ができますか？',
          answer:
            'システムにログインし、実際の管理画面（ダッシュボード）をご確認いただけます。また、貴店が現在Googleマップ上でどれだけのインバウンド客を取りこぼしているか（機会損失）の無料シミュレーションも可能です。',
        },
      ],
      signupCtaFeatures: [
        '最短1分で登録完了',
        'クレジットカード不要',
        '初期費用0円',
      ],
    };
  },
  methods: {
    toggleFaq(index) {
      this.openFaqIndex = this.openFaqIndex === index ? null : index;
    },
  },
};
</script>

<style>
@import url('https://fonts.googleapis.com/css2?family=Noto+Sans+JP:wght@400;500;600;700;900&display=swap');
</style>

<style scoped>
/*
 * LP 幅は .shopadmin-titan-panel-outer と同じ。1232px 列は .tlp__content-inner。
 * 本文フォントは Noto Sans JP（Google Fonts）。未読込時は游ゴシック等へフォールバック。
 */
.tlp {
  display: block;
  width: 100%;
  min-width: 0;
  overflow-x: clip;
  overflow-y: visible;
}

.tlp__canvas {
  box-sizing: border-box;
  width: 100%;
  overflow-x: clip;
  overflow-y: visible;
  font-family: 'Noto Sans JP', 'Yu Gothic', 'Yu Gothic UI', 'Hiragino Kaku Gothic ProN', Meiryo, sans-serif;
  font-size: 16px;
  line-height: 1.6;
  --titan-lp-pad-x: 32px;
  --titan-lp-pad-y: 24px;
  --titan-lp-gap: 20px;

  @container shopadmin-titan (max-width: 1199px) {
    font-size: 14px;
    line-height: 1.55;
    --titan-lp-pad-x: 24px;
    --titan-lp-pad-y: 16px;
    --titan-lp-gap: 14px;
  }
}

.tlp__content-inner {
  box-sizing: border-box;
  width: 100%;
  max-width: 1232px;
  margin-right: auto;
  margin-left: auto;
  padding: 0;

  @container shopadmin-titan (max-width: 1199px) {
    padding: 0 24px;
  }
}

.tlp__header {
  display: block;
  box-sizing: border-box;
  width: 100%;
  min-height: 80px;
  height: 80px;
  background: #fff;
  border-bottom: 1px solid #e5e5e5;
}

.tlp__header-inner {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  gap: 12px 20px;
  min-height: 80px;
  height: 100%;
}

.tlp__header-brand {
  display: flex;
  flex: 1 1 auto;
  align-items: center;
  gap: 24px;
  min-width: 0;
}

.tlp__logo {
  display: block;
  width: 120px;
  height: auto;
  flex-shrink: 0;
}

.tlp__tagline {
  margin: 0;
  max-width: 100%;
  padding: 5px 10px;
  border: 1px solid #ffd6a8;
  border-radius: 8px;
  background: #ffedd4;
  color: #9f2d00;
  font-size: 16px;
  font-weight: 700;
  letter-spacing: 0.02em;
  line-height: 1.35;
}

.tlp__cta {
  display: inline-flex;
  box-sizing: border-box;
  flex-shrink: 0;
  align-items: center;
  justify-content: center;
  width: 170px;
  height: 52px;
  padding: 0;
  border: none;
  border-radius: 9999px;
  background: linear-gradient(90deg, #e7000b 0%, #ff6900 100%);
  color: #fff;
  font-size: 18px;
  font-weight: 900;
  letter-spacing: 0;
  line-height: 1;
  text-align: center;
  text-decoration: none;
  transition: filter 0.15s ease;
}

.tlp__cta:hover,
.tlp__cta:focus-visible {
  filter: brightness(1.04);
  text-decoration: none;
  color: #fff;
}

.tlp__cta:focus-visible {
  outline: 2px solid #ff6900;
  outline-offset: 2px;
}

.tlp__promo-banner {
  display: block;
  box-sizing: border-box;
  width: 100%;
  height: 80px;
  margin: 0;
  background: #e7000b;
}

.tlp__promo-inner {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 80px;
  color: #fff;
  font-size: 32px;
  font-weight: 900;
  letter-spacing: 0.02em;
  line-height: 1.2;
  text-align: center;

  @container shopadmin-titan (max-width: 1199px) {
    font-size: 24px;
  }
}

.tlp__promo-text {
  margin: 0;
  max-width: 100%;
}

/* —— Main visual —— */
.tlp__main {
  display: block;
  min-width: 0;
}

.tlp__mv {
  position: relative;
  z-index: 0;
  box-sizing: border-box;
  width: 100%;
  min-height: 420px;
  overflow: hidden;
}

.tlp__mv-bg {
  position: absolute;
  z-index: 0;
  inset: 0;
  pointer-events: none;
}

.tlp__mv-bg-img {
  display: block;
  width: 100%;
  height: 100%;
  object-fit: cover;
  object-position: 60% 50%;
}

.tlp__mv-inner {
  position: relative;
  z-index: 1;
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  align-items: center;
  justify-content: space-between;
  gap: 0;
  box-sizing: border-box;
  max-width: 1232px;
  margin: 0 auto;
  padding: 80px 0;

  @container shopadmin-titan (max-width: 1199px) {
    padding: 56px 24px;
  }
}

.tlp__mv-copy {
  flex: 1 1 0;
  text-align: left;

  @container shopadmin-titan (max-width: 1199px) {
    flex: 1 1 auto;
    max-width: 40rem;
  }
}

.tlp__mv-title {
  margin: 0 0 40px;
  color: #fff;
  font-size: 60px;
  font-weight: 900;
  letter-spacing: 0.02em;
  line-height: 1.5;

  @container shopadmin-titan (max-width: 1199px) {
    margin-bottom: 28px;
    font-size: 36px;
  }
}

.tlp__mv-title-pill {
  display: inline-block;
  box-sizing: border-box;
  padding: 4px 10px;
  border-radius: 10px;
  background: #fff;
  color: #e7000b;
  font-size: 1em;
  font-weight: 900;
  line-height: 1.35;
  vertical-align: baseline;

  @container shopadmin-titan (max-width: 1199px) {
    padding: 4px 8px;
  }
}

.tlp__mv-lead {
  margin: 0 0 70px;
  color: #fff;
  font-size: 30px;
  font-weight: 700;
  letter-spacing: 0.02em;
  line-height: 1.5;

  @container shopadmin-titan (max-width: 1199px) {
    margin-bottom: 40px;
    font-size: 24px;
  }
}

.tlp__mv-desc {
  margin: 0 0 40px;
  color: #fff;
  font-size: 20px;
  font-weight: 500;
  letter-spacing: 0.02em;
  line-height: 1.6;

  @container shopadmin-titan (max-width: 1199px) {
    margin-bottom: 28px;
    font-size: 18px;
  }
}

.tlp__mv-cta {
  display: inline-flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  box-sizing: border-box;
  width: 540px;
  gap: 8px;
  padding: 14px;
  border: none;
  border-radius: 9999px;
  background: linear-gradient(90deg, #e7000b 0%, #ff6900 100%);
  color: #fff;
  text-decoration: none;
  transition: filter 0.15s ease;

  @container shopadmin-titan (max-width: 1199px) {
    width: 450px;
    padding: 12px;
  }
}

.tlp__mv-cta:hover,
.tlp__mv-cta:focus-visible {
  filter: brightness(1.04);
  color: #fff;
  text-decoration: none;
}

.tlp__mv-cta:focus-visible {
  outline: 2px solid #ff6900;
  outline-offset: 3px;
}

.tlp__mv-cta-badge {
  display: inline-block;
  padding: 6px 10px;
  border: 1px solid #fff;
  border-radius: 8px;
  font-size: 20px;
  font-weight: 700;
  letter-spacing: 0.04em;
  line-height: 1.5;

  @container shopadmin-titan (max-width: 1199px) {
    font-size: 16px;
    padding: 4px 8px;
  }
}

.tlp__mv-cta-main {
  display: block;
  font-size: 32px;
  font-weight: 900;
  letter-spacing: 0.02em;
  line-height: 1.4;

  @container shopadmin-titan (max-width: 1199px) {
    font-size: 24px;
  }
}

.tlp__mv-visual {
  box-sizing: border-box;
  flex: 0 0 625px;
  width: 625px;
  max-width: 100%;
  min-width: 0;
  margin: 0;

  @container shopadmin-titan (max-width: 1199px) {
    flex: 0 0 400px;
    width: 400px;
  }
}

.tlp__mv-visual-img {
  display: block;
  width: 100%;
  height: auto;
  filter: drop-shadow(0 25px 50px rgb(0 0 0 / 25%));
}

.tlp__faq {
  box-sizing: border-box;
  width: 100%;
  margin: 0;
  padding: 96px 0;
  background: #fff7ed;

  @container shopadmin-titan (max-width: 1199px) {
    padding: 80px 0;
  }
}

/* ─── shared section title ─── */
.tlp__section-title {
  margin: 0;
  color: #1c1917;
  font-size: 48px;
  font-style: normal;
  font-weight: 900;
  letter-spacing: 0.02em;
  line-height: 1.3;
  text-align: center;

  @container shopadmin-titan (max-width: 1199px) {
    font-size: 32px;
  }
}

.tlp__section-lead {
  margin: 24px 0 0;
  color: #1c1917;
  font-size: 18px;
  font-weight: 500;
  line-height: 1.7;
  text-align: center;

  @container shopadmin-titan (max-width: 1199px) {
    margin-top: 20px;
    font-size: 16px;
  }
}

/* ─── problem ─── */
.tlp__problem {
  padding: 96px 0;
  background: #fff7ed;

  @container shopadmin-titan (max-width: 1199px) {
    padding: 80px 0;
  }
}

.tlp__problem-title-bar {
  width: 48px;
  height: 4px;
  margin: 16px auto 60px;
  border-radius: 9999px;
  background: #e7000b;

  @container shopadmin-titan (max-width: 1199px) {
    margin: 12px auto 40px;
  }
}

.tlp__problem-grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 58px 32px;
  max-width: 984px;
  margin: 0 auto;
  padding: 0;
  list-style: none;
}

.tlp__problem-card {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  overflow: hidden;
  padding: 32px 32px 0;
  border-radius: 24px;
  border-top: 1px solid #e7e5e4;
  background: #fff;
  box-shadow:
    0 1px 2px -1px #0000001a,
    0 1px 3px 0 #0000001a;
}

.tlp__problem-card-header {
  display: flex;
  align-items: flex-start;
  gap: 10px;
  padding: 0;
}

.tlp__problem-icon {
  flex-shrink: 0;
  width: 44px;
  height: 44px;
}

.tlp__problem-card-text {
  margin: 0;
  color: #1c1917;
  font-size: 24px;
  font-weight: 700;
  line-height: 1.5;
  letter-spacing: 0.01em;
}

.tlp__problem-card-illust {
  display: block;
  width: 100%;
  max-width: 356px;
  height: auto;
  margin-top: 8px;
  margin-inline: auto;
}

.tlp__problem-callout {
  position: relative;
  overflow: hidden;
  max-width: 984px;
  margin: 58px auto 0;
  padding: 32px 40px;
  border-radius: 16px;
  background: #fff;
  box-shadow:
    0 1px 2px -1px #0000001a,
    0 1px 3px 0 #0000001a;
  text-align: center;

  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    height: 5px;
    background: linear-gradient(to right, #e7000b, #ff6900);
  }

  @container shopadmin-titan (max-width: 1199px) {
    padding: 24px 20px;
  }
}

.tlp__problem-callout-line {
  margin: 0 0 12px;
  color: #1c1917;
  font-size: 30px;
  font-weight: 500;
  line-height: 1.6;

  &:last-child {
    margin-bottom: 0;
  }

  @container shopadmin-titan (max-width: 1199px) {
    font-size: 24px;
  }
}

.tlp__problem-callout-em {
  display: inline-block;
  margin: 0 0 4px;
  padding: 8px 12px;
  border-radius: 10px;
  background: #fef2f2;
  color: #e7000b;
  font-size: 36px;
  font-weight: 900;
  line-height: 1.5;

  @container shopadmin-titan (max-width: 1199px) {
    font-size: 28px;
  }
}

/* ─── support ─── */
.tlp__support {
  padding: 96px 0;
  background: #fffdf7;

  @container shopadmin-titan (max-width: 1199px) {
    padding: 80px 0;
  }
}


.tlp__support-grid-wrap {
  position: relative;
  margin: 60px auto 0;

  @container shopadmin-titan (max-width: 1199px) {
    margin-top: 40px;
  }
}

.tlp__support-grid-line {
  position: absolute;
  top: 50%;
  left: 0;
  right: 0;
  transform: translateY(-50%);
  height: 8px;
  background: #3D3A3980;
  z-index: 1;

}

.tlp__support-grid {
  position: relative;
  z-index: 2;
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 24px;
  margin: 0;
  padding: 0;
  list-style: none;
}

.tlp__support-card {
  display: flex;
  flex-direction: column;
  padding: 24px 40px 40px;
  border-radius: 40px;
  border-top: 1px solid #e7e5e4;
  background: #fff;
  box-shadow:
    0 1px 2px -1px #0000001a,
    0 1px 3px 0 #0000001a;

  @container shopadmin-titan (max-width: 1199px) {
    padding: 24px;
    border-radius: 32px;
  }
}

.tlp__support-card-num {
  color: #f35815;
  font-size: 60px;
  font-weight: 900;
  line-height: 1;
  margin-bottom: 16px;
}

.tlp__support-card-illust-wrap {
  display: flex;
  align-items: center;
  justify-content: center;
  margin: -45px 0 0;
}

.tlp__support-card-illust {
  width: 100%;
  height: auto;
}

.tlp__support-card-title {
  margin: 0 0 14px;
  font-size: 24px;
  font-weight: 700;
  line-height: 1.5;

  @container shopadmin-titan (max-width: 1199px) {
    margin-bottom: 12px;
    font-size: 20px;
  }
}

.tlp__support-card-desc {
  margin: 0;
  font-size: 18px;
  font-weight: 500;
  line-height: 1.6;

  @container shopadmin-titan (max-width: 1199px) {
    font-size: 16px;
  }
}

/* ─── optimize ─── */
.tlp__optimize {
  padding: 96px 0;
  background: #fff7ed;

  @container shopadmin-titan (max-width: 1199px) {
    padding: 80px 0;
  }
}


.tlp__optimize-flow {
  display: flex;
  justify-content: center;
  margin: 24px 0 60px;

  @container shopadmin-titan (max-width: 1199px) {
    margin: 20px 0 40px;
  }
}

.tlp__optimize-flow-img {
  display: block;
  width: 100%;
  max-width: 1222px;
  height: auto;
}

.tlp__optimize-features {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 32px;
  max-width: 1024px;
  margin: 0 auto;
}

.tlp__optimize-feature-card {
  display: flex;
  align-items: flex-start;
  gap: 24px;
  padding: 32px;
  border-radius: 24px;
  border-top: 1px solid #e7e5e4;
  background: #fff;
  box-shadow:
    0 1px 2px -1px #0000001a,
    0 1px 3px 0 #0000001a;

  @container shopadmin-titan (max-width: 1199px) {
    border-radius: 20px;
    gap: 16px;
  }
}

.tlp__optimize-feature-icon-wrap {
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 64px;
  height: 64px;
  border-radius: 50%;
  background: #eef2ff;
}

.tlp__optimize-feature-icon-wrap--orange {
  background: #fff7ed;
}

.tlp__optimize-feature-content {
  flex: 1 1 auto;
}

.tlp__optimize-feature-title {
  margin: 0 0 12px;
  font-size: 24px;
  font-weight: 700;
  line-height: 1.5;

  @container shopadmin-titan (max-width: 1199px) {
    font-size: 20px;
  }
}

.tlp__optimize-feature-desc {
  margin: 0;
  font-size: 18px;
  font-weight: 500;
  line-height: 1.6;

  @container shopadmin-titan (max-width: 1199px) {
    font-size: 16px;
  }
}

/* ─── pricing ─── */
.tlp__pricing {
  padding: 96px 0;
  background: #fffdf7;

  @container shopadmin-titan (max-width: 1199px) {
    padding: 80px 0;
  }
}

.tlp__pricing-inner {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.tlp__pricing-card-wrap {
  position: relative;
  width: 100%;
  max-width: 664px;
  margin: 84px auto 0;
}

.tlp__pricing-badge {
  position: absolute;
  top: -24px;
  left: 50%;
  transform: translateX(-50%);
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  width: 200px;
  height: 48px;
  border: 4px solid #1c1917;
  border-radius: 9999px;
  background: #e7000b;
  color: #fff;
  font-size: 20px;
  font-weight: 700;
  z-index: 2;
  white-space: nowrap;
}

.tlp__pricing-badge-star {
  font-size: 20px;
}

.tlp__pricing-card {
  background: transparent;
  border-radius: 44px;
  color: #fff;
  overflow: hidden;
  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.15);
}

.tlp__pricing-card-header {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 56px;
  background: #292524;
  border-bottom: 1px solid #44403b;
}

.tlp__pricing-card-body {
  padding: 56px;
  background: #1c1917;
}

.tlp__pricing-plan-tag {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  height: 40px;
  margin-bottom: 24px;
  padding: 0 24px;
  border-radius: 9999px;
  background: #fb2c36;
  box-shadow:
    0px 2px 4px -2px #0000001a,
    0px 4px 6px -1px #0000001a;
  color: #fff;
  font-size: 20px;
  font-weight: 900;
}

.tlp__pricing-plan-name {
  margin: 0 0 16px;
  font-size: 20px;
  font-weight: 700;
  line-height: 1.5;
  color: #d4d4d8;
}

.tlp__pricing-price-wrap {
  display: flex;
  align-items: baseline;
  justify-content: center;
  gap: 4px;
  color: #ff3b3b;
}

.tlp__pricing-price-prefix {
  margin-right: 12px;
  color: #fff;
  font-size: 48px;
  font-weight: 900;
  line-height: 1;
  letter-spacing: 0.02em;
}

.tlp__pricing-price-symbol {
  font-size: 96px;
  font-weight: 900;
  line-height: 1;
}

.tlp__pricing-price-num {
  font-size: 96px;
  font-weight: 900;
  line-height: 1;
}

.tlp__pricing-price-note {
  margin: 8px 0 24px;
  color: #a1a1aa;
  font-size: 18px;
  font-weight: 700;
  line-height: 1.5;
}

.tlp__pricing-condition {
  display: inline-flex;
  align-items: baseline;
  padding: 17px;
  border-top: 1px solid #44403b;
  border-radius: 14px;
  background: #1c191780;
  font-size: 20px;
  font-weight: 700;
  line-height: 1.5;
}

.tlp__pricing-condition-em {
  color: #ff6467;
  font-size: 32px;
  font-weight: 700;
  line-height: 1;
}

.tlp__pricing-condition-sep {
  margin: 0 8px;
  color: #52525b;
}

.tlp__pricing-features {
  display: flex;
  flex-direction: column;
  gap: 24px;
  margin: 0 0 64px;
  padding: 0;
  list-style: none;
}

.tlp__pricing-feature-item {
  display: flex;
  align-items: center;
  gap: 16px;
}

.tlp__pricing-feature-check-wrap {
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 28px;
  height: 28px;
  border-radius: 50%;
  background: #00c95033;
}

.tlp__pricing-feature-check {
  width: 20px;
  height: 20px;
}

.tlp__pricing-feature-text {
  font-size: 20px;
  font-weight: 700;
  line-height: 1.5;
}

.tlp__pricing-action {
  padding: 0;
}

.tlp__pricing-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 80px;
  border-radius: 9999px;
  background: linear-gradient(90deg, #e7000b 0%, #ff6900 100%);
  box-shadow:
    0px 8px 10px -6px #82181a80,
    0px 20px 25px -5px #82181a80;
  color: #fff;
  font-size: 24px;
  font-weight: 900;
  letter-spacing: 0.02em;
  text-decoration: none;
  transition: filter 0.15s ease, box-shadow 0.15s ease;
}

.tlp__pricing-btn:hover,
.tlp__pricing-btn:focus-visible {
  filter: brightness(1.1);
}

.tlp__pricing-btn:focus-visible {
  outline: 2px solid #1c1917;
  outline-offset: 2px;
}

.tlp__pricing-notes-wrap {
  margin-top: 36px;
  padding: 0;
}

.tlp__pricing-notes {
  padding: 16px;
  border-radius: 12px;
  background: #292524;
  border-top: 1px solid #44403b;
}

.tlp__pricing-note {
  margin: 0 0 8px;
  color: #a6a09b;
  font-size: 16px;
  font-weight: 500;
  line-height: 1.5;
  padding-left: 1em;
  text-indent: -1em;
}

.tlp__pricing-note:last-child {
  margin-bottom: 0;
}

/* ─── results ─── */
.tlp__results {
  padding: 96px 0;
  background: #fffdf7;

  @container shopadmin-titan (max-width: 1199px) {
    padding: 80px 0;
  }
}

.tlp__results-list {
  display: flex;
  flex-direction: column;
  gap: 40px;
  margin: 64px 0 0;

  @container shopadmin-titan (max-width: 1199px) {
    gap: 28px;
    margin-top: 40px;
  }
}

.tlp__results-card {
  position: relative;
  display: grid;
  grid-template-columns: 1fr auto;
  gap: 50px;
  padding: 48px 40px;
  background: #fff;
  border: 1px solid #e7e5e4;
  border-radius: 40px;
  box-shadow:
    0px 1px 2px -1px #0000001a,
    0px 1px 3px 0px #0000001a;
  overflow: hidden;

  @container shopadmin-titan (max-width: 1199px) {
    gap: 24px;
    padding: 32px 24px;
    border-radius: 28px;
  }
}

.tlp__results-tags {
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
  margin: 0;

  @container shopadmin-titan (max-width: 1199px) {
    gap: 8px;
  }
}

.tlp__results-tag {
  display: inline-flex;
  align-items: center;
  padding: 4px 12px;
  border-radius: 8px;
  font-size: 16px;
  font-weight: 700;
  line-height: 1.25;

  @container shopadmin-titan (max-width: 1199px) {
    padding: 3px 8px;
    border-radius: 4px;
    font-size: 12px;
  }
}

.tlp__results-tag--location {
  background: #1c1917;
  color: #fff;
}

.tlp__results-tag--category {
  background: #e7e5e4;
  color: #1c1917;
}

.tlp__results-tag--period {
  background: #fee2e2;
  color: #e7000b;
}

.tlp__results-card-title {
  margin: 0;
  font-size: 30px;
  font-weight: 900;
  line-height: 1.4;

  @container shopadmin-titan (max-width: 1199px) {
    font-size: 24px;
  }
}

.tlp__results-card-desc {
  margin: 0;
  font-size: 18px;
  font-weight: 500;
  line-height: 1.5;
  color: #57534d;

  @container shopadmin-titan (max-width: 1199px) {
    font-size: 16px;
  }
}

.tlp__results-card-bg {
  position: absolute;
  bottom: 0;
  left: 0;
  width: 50%;
  object-fit: contain;
  object-position: left bottom;
  z-index: 0;
}

.tlp__results-card-body {
  position: relative;
  z-index: 1;
  display: flex;
  flex-direction: column;
  gap: 20px;
  min-width: 0;

  @container shopadmin-titan (max-width: 1199px) {
    gap: 16px;
  }
}

.tlp__results-metrics {
  position: relative;
  z-index: 1;
  display: flex;
  gap: 16px;
  align-self: center;

  @container shopadmin-titan (max-width: 1199px) {
    gap: 12px;
  }
}

.tlp__results-metric {
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  width: 160px;
  flex-shrink: 0;
  box-sizing: border-box;
  padding: 14px 12px;
  background: #fff7ed;
  border: 1px solid #e7e5e4;
  border-radius: 14px;
  box-shadow:
    0px 1px 2px -1px #0000001a,
    0px 1px 3px 0px #0000001a;

  @container shopadmin-titan (max-width: 1199px) {
    width: 140px;
    padding: 10px 8px;
    border-radius: 10px;
  }
}

.tlp__results-metric-before {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  box-sizing: border-box;
  gap: 2px;
  margin: 0 0 10px;
  padding: 6px;
  background: #fff;
  border: 1px solid #e7e5e4;
  border-radius: 4px;
  color: #433E3B;
  font-size: 16px;
  font-weight: 700;
  line-height: 1.3;
  letter-spacing: 0.04em;

  @container shopadmin-titan (max-width: 1199px) {
    font-size: 12px;
  }
}

.tlp__results-metric-name {
  margin: 0 0 8px;
  font-size: 18px;
  font-weight: 600;
  color: #433e3b;

  @container shopadmin-titan (max-width: 1199px) {
    font-size: 14px;
    margin-bottom: 6px;
  }
}

.tlp__results-metric-after {
  display: flex;
  flex-wrap: wrap;
  align-items: baseline;
  margin: 0 0 12px;
  line-height: 1;
  color: #e7000b;
}

.tlp__results-metric-after-num {
  font-size: 36px;
  font-weight: 900;

  @container shopadmin-titan (max-width: 1199px) {
    font-size: 28px;
  }
}

.tlp__results-metric-after-suffix {
  font-size: 20px;
  font-weight: 900;
  line-height: 1.6;

  @container shopadmin-titan (max-width: 1199px) {
    font-size: 16px;
  }
}

.tlp__results-metric-illust {
  display: block;
  margin-top: auto;
  width: 100%;
  height: auto;
}

/* ─── matching ─── */
.tlp__matching {
  padding: 96px 0;
  background: #fff7ed;

  @container shopadmin-titan (max-width: 1199px) {
    padding: 80px 0;
  }
}


.tlp__matching-grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 48px;
  margin: 64px auto 0;
  padding: 0;
  box-sizing: border-box;
  width: 100%;

  @container shopadmin-titan (max-width: 1199px) {
    gap: 32px;
    margin-top: 48px;
  }
}

.tlp__matching-card {
  position: relative;
  display: flex;
  flex-direction: column;
  box-sizing: border-box;
  border-radius: 48px;
  background: #fff;
  overflow: hidden;
  padding: 50px 50px 30px;

  @container shopadmin-titan (max-width: 1199px) {
    border-radius: 32px;
    padding: 36px 36px 24px;
  }
}

.tlp__matching-card--fit {
  border: 2px solid #b9f8cf;
  box-shadow:
    0px 1px 2px -1px #0000001a,
    0px 1px 3px 0px #0000001a;

  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    z-index: 1;
    width: 100%;
    height: 8px;
    background: #00c950;
  }
}

.tlp__matching-card--unfit {
  border: 2px solid #e7e5e4;
  box-shadow:
    0px 1px 2px -1px #0000001a,
    0px 1px 3px 0px #0000001a;

  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    z-index: 1;
    width: 100%;
    height: 8px;
    background: #d6d3d1;
  }
}

.tlp__matching-card-title {
  display: flex;
  align-items: center;
  gap: 12px;
  margin: 0 0 32px;
  padding: 0;
  color: #1c1917;

  @container shopadmin-titan (max-width: 1199px) {
    margin-bottom: 24px;
  }
}

.tlp__matching-card-title-icon-wrap {
  display: flex;
  flex-shrink: 0;
  align-items: center;
  justify-content: center;
  width: 44px;
  height: 44px;
  border-radius: 50%;

  @container shopadmin-titan (max-width: 1199px) {
    width: 36px;
    height: 36px;
  }
}

.tlp__matching-card--fit .tlp__matching-card-title-icon-wrap {
  background: #dcfce7;
}

.tlp__matching-card--unfit .tlp__matching-card-title-icon-wrap {
  background: #f5f5f4;
}

.tlp__matching-card-title-text {
  margin: 0;
  font-weight: 900;
  font-size: 30px;
  line-height: 1.2;
  letter-spacing: 0.02em;

  @container shopadmin-titan (max-width: 1199px) {
    font-size: 24px;
  }
}

.tlp__matching-card-title-icon {
  flex-shrink: 0;
  width: 28px;
  height: 28px;

  @container shopadmin-titan (max-width: 1199px) {
    width: 24px;
    height: 24px;
  }
}

.tlp__matching-list {
  flex: 1 1 auto;
  display: flex;
  flex-direction: column;
  gap: 24px;
  margin: 0 0 16px;
  padding: 0;
  list-style: none;

  @container shopadmin-titan (max-width: 1199px) {
    gap: 16px;
  }
}

.tlp__matching-item {
  display: flex;
  align-items: flex-start;
  gap: 16px;
}

.tlp__matching-check {
  flex-shrink: 0;
  margin-top: 2px;
}

.tlp__matching-text {
  font-size: 18px;
  font-weight: 700;
  line-height: 1.6;
  color: #1c1917;

  @container shopadmin-titan (max-width: 1199px) {
    font-size: 16px;
  }
}

.tlp__matching-list--unfit .tlp__matching-text {
  color: #79716b;
  font-weight: 500;
}

.tlp__matching-illust-wrap {
  display: flex;
  justify-content: center;
  padding: 0;
  margin-top: auto;
}

.tlp__matching-illust {
  max-width: 100%;
  height: auto;
}

.tlp__faq-list {
  display: flex;
  flex-direction: column;
  gap: 16px;
  max-width: 920px;
  margin: 60px auto 0;
  padding: 0;
  list-style: none;

  @container shopadmin-titan (max-width: 1199px) {
    margin-top: 40px;
  }
}

.tlp__faq-item {
  box-sizing: border-box;
  margin: 0;
  padding: 24px;
  overflow: hidden;
  border: 1px solid #e7e5e4;
  border-radius: 16px;
  background: #fff;
  box-shadow:
    0 1px 2px -1px #0000001a,
    0 1px 3px 0 #0000001a;

  @container shopadmin-titan (max-width: 1199px) {
    padding: 20px;
  }
}

.tlp__faq-trigger {
  display: flex;
  width: 100%;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  padding: 0;
  border: none;
  background: transparent;
  color: inherit;
  font: inherit;
  text-align: left;
  cursor: pointer;
}

.tlp__faq-trigger:focus-visible {
  outline: 2px solid #ff6900;
  outline-offset: -2px;
}

.tlp__faq-trigger-main {
  display: flex;
  flex: 1 1 auto;
  align-items: flex-start;
  gap: 8px;
  min-width: 0;
}

.tlp__faq-q-mark {
  flex-shrink: 0;
  color: #e7000b;
  font-size: 20px;
  font-weight: 900;
  line-height: 1.45;
}

.tlp__faq-q-text {
  flex: 1 1 auto;
  min-width: 0;
  color: #1c1917;
  font-size: 20px;
  font-weight: 900;
  line-height: 1.45;
}

.tlp__faq-icon {
  --faq-icon-stroke: 1.7px;
  --faq-icon-arm: 12px;
  flex-shrink: 0;
}

.tlp__faq-icon-bg {
  display: flex;
  box-sizing: border-box;
  align-items: center;
  justify-content: center;
  width: 36px;
  height: 36px;
  border-radius: 50%;
  background: #fff7ed;
}

.tlp__faq-icon-glyph {
  position: relative;
  display: block;
  width: var(--faq-icon-arm);
  height: var(--faq-icon-arm);
}

.tlp__faq-icon-line {
  position: absolute;
  top: 50%;
  left: 50%;
  display: block;
  border-radius: 1px;
  background: #e7000b;
  transform: translate(-50%, -50%);
  transition: opacity 0.25s ease, transform 0.25s ease;
}

.tlp__faq-icon-line--h {
  width: var(--faq-icon-arm);
  height: var(--faq-icon-stroke);
}

.tlp__faq-icon-line--v {
  width: var(--faq-icon-stroke);
  height: var(--faq-icon-arm);
  opacity: 1;
  transform: translate(-50%, -50%) scaleY(1);
}

.tlp__faq-icon.is-open .tlp__faq-icon-line--v {
  opacity: 0;
  transform: translate(-50%, -50%) scaleY(0);
}

@media (prefers-reduced-motion: reduce) {
  .tlp__faq-icon-line {
    transition: none;
  }
}

.tlp__faq-anim {
  display: grid;
  grid-template-rows: 0fr;
  transition: grid-template-rows 0.4s ease;
}

.tlp__faq-anim.is-open {
  grid-template-rows: 1fr;
}

@media (prefers-reduced-motion: reduce) {
  .tlp__faq-anim {
    transition: none;
  }
}

.tlp__faq-anim-inner {
  min-height: 0;
  overflow: hidden;
}

.tlp__faq-panel {
  margin: 16px -24px -24px;
  padding: 20px 24px 24px;
  border-top: 1px solid #f5f5f4;
  background: rgb(255 247 237 / 30%);
  border-radius: 0 0 15px 15px;

  @container shopadmin-titan (max-width: 1199px) {
    margin: 16px -20px -20px;
    padding: 20px 20px 20px;
    border-radius: 0 0 15px 15px;
  }
}

.tlp__faq-answer {
  display: flex;
  align-items: flex-start;
  gap: 8px;
  margin: 0;
  padding: 0;
  color: #44403b;
  font-size: 18px;
  font-weight: 700;
  line-height: 1.625;

  @container shopadmin-titan (max-width: 1199px) {
    font-size: 16px;
  }
}

.tlp__faq-a-mark {
  flex-shrink: 0;
  color: #a8a29e;
  font-weight: 700;
}

.tlp__faq-answer-body {
  flex: 1 1 0;
  min-width: 0;
}

.tlp__signup-cta {
  --signup-cta-gradient-h: 8px;
  --signup-cta-gap-after-gradient: 110px;
  position: relative;
  z-index: 0;
  box-sizing: border-box;
  width: 100%;
  margin: 0;
  padding: calc(var(--signup-cta-gradient-h) + var(--signup-cta-gap-after-gradient)) 0 100px;
  border-top: 1px solid #ffe2e2;
  overflow: clip;
  background: linear-gradient(135deg, #fef2f2 0%, #fff7ed 50%, #fffbeb 100%);

  @container shopadmin-titan (max-width: 1199px) {
    --signup-cta-gap-after-gradient: 64px;
    padding: calc(var(--signup-cta-gradient-h) + var(--signup-cta-gap-after-gradient)) 0 80px;
  }
}

.tlp__signup-cta-gradient-wrap {
  position: absolute;
  top: 0;
  right: 0;
  left: 0;
  z-index: 1;
  display: flex;
  justify-content: center;
  box-sizing: border-box;
  width: 100%;
  pointer-events: none;
}

.tlp__signup-cta-gradient {
  box-sizing: border-box;
  width: 80%;
  max-width: 1400px;
  height: var(--signup-cta-gradient-h);
  background: linear-gradient(90deg, #fb2c36 0%, #ff6900 100%);
}

.tlp__signup-cta-inner {
  position: relative;
  z-index: 2;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 40px;
  text-align: center;
}

.tlp__signup-cta-deco {
  position: absolute;
  z-index: 1;
  display: block;
  pointer-events: none;
}

.tlp__signup-cta-deco--tr {
  top: -80px;
  right: -3%;
  width: 512px;
  height: 512px;
}

.tlp__signup-cta-deco--bl {
  bottom: -80px;
  left: -3%;
  width: 544px;
  height: 544px;
}

.tlp__signup-cta-title {
  margin: 0;
  font-size: 48px;
  font-weight: 900;
  line-height: 1.5;
  letter-spacing: 0.02em;

  @container shopadmin-titan (max-width: 1199px) {
    font-size: 32px;
  }
}

.tlp__signup-cta-title-row {
  display: block;
}

.tlp__signup-cta-highlight {
  display: inline-block;
  margin-right: 10px;
  padding: 9px 24px;
  border: 2px solid #ffe2e2;
  border-radius: 14px;
  background: #fff;
  color: #e7000b;

  @container shopadmin-titan (max-width: 1199px) {
    padding: 6px 16px;
  }
}

.tlp__signup-cta-title-tail {
  font-weight: 900;
  font-size: inherit;
  line-height: inherit;
  letter-spacing: inherit;
}

.tlp__signup-cta-lead {
  margin: 0;
  color: #1c1917;
  font-size: 24px;
  font-weight: 700;
  letter-spacing: 0.02em;

  @container shopadmin-titan (max-width: 1199px) {
    font-size: 20px;
  }
}

.tlp__signup-cta-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  box-sizing: border-box;
  width: 670px;
  height: 100px;
  border: none;
  border-radius: 9999px;
  background: linear-gradient(90deg, #e7000b 0%, #ff6900 100%);
  box-shadow: 0 25px 50px -12px #ffc9c9;
  color: #fff;
  font-size: 30px;
  font-weight: 900;
  letter-spacing: 0.02em;
  text-align: center;
  text-decoration: none;
  transition: filter 0.15s ease, box-shadow 0.15s ease;

  @container shopadmin-titan (max-width: 1199px) {
    font-size: 24px;
    height: 80px;
    width: 550px;
  }
}

.tlp__signup-cta-btn:hover,
.tlp__signup-cta-btn:focus-visible {
  filter: brightness(1.04);
  box-shadow: 0 25px 50px -12px #ffc9c9;
  text-decoration: none;
  color: #fff;
}

.tlp__signup-cta-btn:focus-visible {
  outline: 2px solid #ff6900;
  outline-offset: 3px;
}

.tlp__signup-cta-features {
  display: flex;
  flex-wrap: nowrap;
  justify-content: center;
  align-items: center;
  gap: 12px 28px;
  box-sizing: border-box;
  width: fit-content;
  max-width: 100%;
  margin: 0;
  padding: 16px 32px;
  border: 1px solid #e5e5e5;
  border-radius: 9999px;
  background: #fff;
  list-style: none;

  @container shopadmin-titan (max-width: 1199px) {
    padding: 12px 24px;
  }
}

.tlp__signup-cta-feature {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  margin: 0;
  color: #1c1917;
  font-size: 18px;
  font-weight: 700;

  @container shopadmin-titan (max-width: 1199px) {
    font-size: 16px;
  }
}

.tlp__signup-cta-check {
  display: block;
  flex-shrink: 0;
}

.tlp__footer {
  display: flex;
  align-items: center;
  justify-content: center;
  box-sizing: border-box;
  width: 100%;
  min-height: 100px;
  height: 100px;
  margin: 0;
  background: #1a1a1a;
}

.tlp__footer-logo {
  display: block;
  width: 106px;
  height: auto;
  flex-shrink: 0;
}
</style>
